import RestX from 'highered-utils/restx';
import i18n from '~/i18n';
import { getSubDomain } from '~/utils/urlUtils';

// The default domain is efmdglobal. The only usecase of this variable is on localhost :P
export const DEFAULT_DOMAIN = 'efmdglobal';

class UniversityService {
    static school = null;
    static domain = null;

    static initialize() {
        // Fetch university data and set window-title
        const abbr = getSubDomain();
        if (abbr) {
            document.title = ''.concat(
                (abbr + '').toUpperCase(),
                ' ',
                i18n.t('general.documentTitle')
            );
        }
        this.domain = abbr || DEFAULT_DOMAIN; // Sets CASS as default domain

        // Get university data
        this.getCurrentSchoolData();
    }

    // Gets the current data of the school. Defaults to CASS.
    // The return type is a promise, and the payload is null on failure.
    static getCurrentSchoolData() {
        // If the school data has already been fetched, return
        if (this.school !== null) {
            return Promise.resolve(this.school);
        }

        const domain = getSubDomain() || DEFAULT_DOMAIN; // CASS is default for localhost

        return RestX.getInterfaces()
            .university.get({
                abbr: domain,
            })
            .then(data => {
                data = data.data || data;
                if (data instanceof Array && data.length > 0 && data[0].id) {
                    this.school = data[0];
                    return data[0]; // The school data
                }
                return Promise.reject({
                    reason: 'Missing expected data',
                    data,
                });
            })
            .catch(err => {
                console.log(err);
                return null;
            });
    }
    static hasCalendar() {
        //TODO: Put in ResourceService instead after refactor.
        return this.getCurrentSchoolData().then(data => {
            if (data.id) {
                return RestX.getInterfaces()
                    .calendar.type.get({
                        school_id: data.id,
                    })
                    .then(appointments => {
                        this.types = appointments.data.results;
                        return this.types.length > 0;
                    });
            }
        });
    }
    static getCurrentDomain() {
        return this.domain || getSubDomain() || DEFAULT_DOMAIN;
    }
}

export default UniversityService;
